import TableOfContents, { TocItem } from 'components/shared/TableOfContents/TableOfContents';

interface DisclosureCollectionTableOfContentsProps {
  items: TocItem[];
  defaultExpanded?: boolean;
}

const DisclosureCollectionTableOfContents = ({
  items,
  defaultExpanded = true,
}: DisclosureCollectionTableOfContentsProps) => {
  return (
    <TableOfContents
      items={items}
      testId="disclosureTableOfContentsTitle"
      className="mb-12"
      defaultExpanded={defaultExpanded}
      showNumbers
    />
  );
};

export default DisclosureCollectionTableOfContents;
